module.exports = __webpack_public_path__ + "static/media/cupcake-loaded.b5a16cef.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/2017-11-4/cupcake-loaded.jpg
// module id = 799
// module chunks = 0